import axios from "axios";
import { APIConstants } from "../../constants/ApiConstants";

export const exportData = async (
  generatedURL: string,
  modelName: string,
  hashKey: string,
  hashValue: string
) => {
  const searchParams = new URLSearchParams(generatedURL);
  const searchValue = searchParams.get("search");
  const filtersValue = searchParams.get("filters");

  const emailData = {
    modelName: modelName,
    hashKey: hashKey,
    hashValue: hashValue,
    filters: filtersValue || "",
    search: searchValue || "",
  };
  const exportURL = process.env.REACT_APP_API_URL + APIConstants.export
  try {
    const response = await axios.post(
      exportURL,
      emailData
    );
    return response;
  } catch (error) {
    console.error("Error sending email:", error);
    throw error;
  }
};
